module.exports = __webpack_public_path__ + "static/media/ramen-light-animated.ded0cc8a.gif";